function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createContext, useContext, useMemo } from 'react';
import { isArray, isFunction } from '@okee-uikit/react-utils';
export function useTableRowsInit(data, options) {
  var getId = options.getId,
      getChildren = options.getChildren;
  return useMemo(function () {
    var rowIndex = 0;

    function getRowInfos(data, getId, getChildren, level, parentPath, parentSerials) {
      return data.map(function (row, index) {
        rowIndex++;
        var serials = [].concat(_toConsumableArray(parentSerials), [index]);
        var id = getId(row, index);
        var path = [].concat(_toConsumableArray(parentPath), [id]);
        var rowChildren = getChildren(row, index);
        var isLeaf = !rowChildren;
        var rowInfo = {
          row: row,
          id: id,
          path: path,
          index: index,
          serials: serials,
          level: level,
          isLeaf: isLeaf,
          rowIndex: rowIndex,
          children: undefined
        };
        rowInfo.children = isArray(rowChildren) && getRowInfos(rowChildren, getId, getChildren, level + 1, path, serials) || undefined;
        return rowInfo;
      });
    }

    var firstLevelRowInfos = getRowInfos(data, getId, getChildren, 1, [], []);
    return [firstLevelRowInfos, rowIndex];
  }, [data, getId, getChildren]);
}
export function useTableRowsPostInit(current, treeActive, treeActions, expansionActive, expansionActions, selected, selectionActions, selectOptions) {
  return useMemo(function () {
    if (treeActions || expansionActions || selectionActions || selectOptions) {
      var walk = function walk(rows) {
        return rows.map(function (row) {
          var level = row.level,
              id = row.id,
              path = row.path,
              children = row.children;

          var _ref = selectOptions || {},
              componentProps = _ref.componentProps;

          var getProps = isFunction(componentProps) && componentProps || function () {
            return componentProps;
          };

          return _objectSpread(_objectSpread({}, row), {}, {
            tree: treeActions && {
              active: treeActions.isActive(path),
              activate: function activate(e) {
                return treeActions.activate(path, e);
              },
              inactivate: function inactivate(e) {
                return treeActions.inactivate(path, e);
              },
              toggle: function toggle(e) {
                return treeActions.toggle(path, e);
              }
            },
            expansion: level === 1 && expansionActions && {
              active: expansionActions.isActive(id),
              activate: function activate(e) {
                return expansionActions.activate(id, e);
              },
              inactivate: function inactivate(e) {
                return expansionActions.inactivate(id, e);
              },
              toggle: function toggle(e) {
                return expansionActions.toggle(id, e);
              }
            } || undefined,
            selection: selectionActions && {
              selected: selectionActions.isSelected(id),
              select: function select(e) {
                return selectionActions.select(id, e);
              },
              unselect: function unselect(e) {
                return selectionActions.unselect(id, e);
              },
              toggle: function toggle(e) {
                return selectionActions.toggle(id, e);
              }
            },
            children: children && walk(children),
            compProps: getProps(row)
          });
        });
      };

      return walk(current);
    }

    return current;
  }, [current, treeActive, treeActions, expansionActive, expansionActions, selected, selectionActions]);
}
export var RowsContext = createContext({
  rowCount: 0,
  original: [],
  current: [],
  emptyText: undefined,
  renderEmpty: undefined
});
export var useTableRows = function useTableRows() {
  return useContext(RowsContext);
};
export function getAllIdsRecursively(rowInfos) {
  var ids = [];
  rowInfos.forEach(function (row) {
    var id = row.id,
        children = row.children,
        _row$compProps = row.compProps;
    _row$compProps = _row$compProps === void 0 ? {} : _row$compProps;
    var disabled = _row$compProps.disabled;
    !disabled && ids.push(id);

    if (children) {
      ids.push.apply(ids, _toConsumableArray(getAllIdsRecursively(children)));
    }
  });
  return ids;
}
export function isAllSelectedRecursively(rowInfos, allDisabled) {
  return !!rowInfos.length && rowInfos.every(function (r) {
    var _a;

    return !allDisabled && ((_a = r.compProps) === null || _a === void 0 ? void 0 : _a.disabled) || r.selection && r.selection.selected && (r.children && r.children.length ? isAllSelectedRecursively(r.children, allDisabled) : true);
  });
}
export function isAllDisabledRecursively(rowInfos) {
  return !rowInfos.length || rowInfos.every(function (r) {
    var _a;

    return ((_a = r.compProps) === null || _a === void 0 ? void 0 : _a.disabled) && (!r.children || isAllDisabledRecursively(r.children));
  });
}